import { useNavigate } from "react-router-dom";
import logo from "../assets";
import { userStore } from "../store";
import { login } from "../constant/urls";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      userStore.logout();

      navigate(login, { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);

      navigate(login, { replace: true });
    }
  };

  return (
    <header className="bg-gradient-to-br from-blue-900 to-blue-100 text-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <img
          src={logo}
          alt="Company Logo"
          className="h-10 w-auto cursor-pointer"
          onClick={() => navigate("/")}
        />

        {userStore.isLoggedIn && (
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 bg-blue-200 hover:bg-blue-800 text-white px-4 py-2 rounded-md transition-colors duration-200"
            aria-label="Logout"
          >
            <span>Logout</span>
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
